import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import { Login, Signup } from './pages/Auth';
import Logout from './pages/Logout';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Project from './pages/Project';
import Layout from './pages/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      // Public-only routes (redirect if logged in)
      { path: '/logout', element: <Logout /> },
      {
        element: <PublicRoute />,
        children: [
          { path: '/', element: <Home /> },
          { path: '/pricing', element: <Pricing /> },
          { path: '/login', element: <Login /> },
          { path: '/signup', element: <Signup /> },
        ],
      },

      // Protected routes
      {
        element: <ProtectedRoute />,
        children: [
          { path: '/', element: <Navigate to="/dashboard" /> },
          { path: '/dashboard', element: <Dashboard /> },
          { path: '/settings', element: <Navigate to="/settings/user" /> },
          { path: '/settings/:tab', element: <Settings /> },
          { path: '/project/:pid', element: <Project /> },
        ],
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
